// extracted by mini-css-extract-plugin
module.exports = {"MainLayout":"seo-content_MainLayout__woQ7Z","grey-block":"seo-content_grey-block__Fr_rN","youtube-player":"seo-content_youtube-player__Hz1Cq"};